const SHOW_SNACK = 'SHOW_SNACK'
const HIDE_SNACK = 'HIDE_SNACK'
const QUEUE_MESSAGES = 'QUEUE_MESSAGES'

const initialState = {
  show: false,
  isQueueActive: false,
  message: '',
  messageQueue: []
}

const state = { ...initialState }

const mutations = {
  [SHOW_SNACK]: function (state, payload) {
    state.show = true
    state.message = payload
  },
  [HIDE_SNACK]: function (state) {
    if (state.isQueueActive) {
      state.show = false
      state.message = state.messageQueue[0]
      state.messageQueue.shift()

      if (state.messageQueue.length) {
        state.show = true
      } else {
        state.show = false
        state.isQueueActive = false
      }
    } else {
      state.show = false
    }
  },
  [QUEUE_MESSAGES]: function (state, payload) {
    state.messageQueue = payload
    state.isQueueActive = true

    state.message = payload[0]
    state.show = true
  }
}

const actions = {
  showSnack ({ commit }, payload) {
    commit(SHOW_SNACK, payload)
  },
  showMessageQueue ({ commit }, payload) {
    commit(QUEUE_MESSAGES, payload)
  },
  hideSnack ({ commit }) {
    commit(HIDE_SNACK)
  }
}

const getters = {
  getMessage (state) {
    return state.message
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
